import React from "react";
import PageHero from "../components/PageHero";
import { SectionLabel } from "../components/Shared";
import { TERMS_SECTIONS, IMAGES } from "../config/siteConfig";

export default function RefundPage() {
  return (
    <>
      <PageHero
        label="Legal"
        title="Terms &"
        highlight="Conditions."
        subtitle="Terms of Use and Refund Policy for www.inrisoft.com by Inri Software Private Limited."
        image={IMAGES.hero}
      />
      <section className="bg-[#F7F7F5] py-24 md:py-36" data-testid="refund-section">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 space-y-10">
          <SectionLabel>Terms of Use</SectionLabel>
          <h2 className="font-display text-3xl md:text-4xl text-[#111111]">Terms of Use</h2>
          {TERMS_SECTIONS.map((s) => (
            <article key={s.title}>
              <h3 className="font-display text-2xl text-[#111111] mb-4">{s.title}</h3>
              <p className="font-body text-[#555] leading-relaxed">{s.body}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
